// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"177":"home","364":"winner","445":"person","660":"winners","826":"index"}[chunkId] + "." + {"177":"a38eb322","364":"ab31a979","445":"f38c6f03","660":"d0d1c021","826":"7b538afb"}[chunkId] + ".css";
};